
import { FormInputWrapper } from '@myxplor/forms'
import { CalendarIcon } from '@myxplor/icons'
import moment from 'moment'
import React, { Component } from 'react'
import DayPickerInput from 'react-day-picker/DayPickerInput'
import 'react-day-picker/lib/style.css'
import MomentLocaleUtils, { formatDate, parseDate } from 'react-day-picker/moment'

const DATE_FORMAT = 'DD/MM/YYYY'
const DATE_FORMAT_EXTERNAL = 'YYYY-MM-DD'

export default class MondayDayPicker extends Component {

  constructor(props) {
    super(props)
    this.handleChange = this.handleChange.bind(this)
  }

  handleChange(day) {
    if (day) {
      this.props.onChange([this.props.name], moment(day).format(DATE_FORMAT_EXTERNAL))
    }
  }

  render() {
    const {
      name,
      required,
      label,
      errors,
      loading,
      value,
      readOnly = false,
      future = false,
      past,
    } = this.props

    return (
      <FormInputWrapper
        name={name}
        label={label}
        required={required}
        errors={errors}
        loading={loading}
      >
        <DayPickerInput 
          inputProps={{ readOnly: true, disabled: readOnly }}
          formatDate={formatDate}
          parseDate={parseDate}
          onDayChange={this.handleChange}
          selectedDays={value}
          value={value ? moment(value, DATE_FORMAT_EXTERNAL).format(DATE_FORMAT) : ''}
          placeholder={DATE_FORMAT}
          format={DATE_FORMAT}
          dayPickerProps={{
            firstOfMonth: day => day.getDate() === 1,
            disabledDays: [
              day => day.getDay() !== 1,
              {
                after: future ? null : new Date(),
                before: moment().subtract(past, 'day').toDate()
              },
            ],
            localeUtils: MomentLocaleUtils,
          }}
        />
        <CalendarIcon className="formDatePicker--icon" />
      </FormInputWrapper>
    )
  }
}



// WEBPACK FOOTER //
// ./src/care-enrolments/accs/form/monday-day-picker.jsx